export default __webpack_public_path__ + "static/media/RDProgram_spanish.2c7b37c7.png";